import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskReportsCustomCreateRoute: InvariantJiraRoute = {
	name: 'servicedesk-reports-custom-create',
	path: '/jira/servicedesk/projects/:projectKey/reports/custom/new',
};
